import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import cx from "classnames";
import styles from "styles/modules/searchPage.module.scss";
import { RouteWithTabs } from "helpers";
import InputBlock from "./InputBlock";
import TabContent from "./TabContent";

import AttributesFiltersForm from "../../pages/Ordering/common/AttributesFiltersForm";

const GRID_TABS = ["task", "resource", "spec", "clevent", "customer", "appeal", "contact_person"];

function mapStateToProps(state, props) {
    const { hash, entity } = props.match.params;
    const searchId = `${hash}-${entity}`;
    return {
        searchId: searchId,
        query: state.search.searches[hash] || "",
    };
}

const mapDispatchToProps = {};

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.getSearchEntity = this.getSearchEntity.bind(this);
        this.getSearchHash = this.getSearchHash.bind(this);
        this.renderTabs = this.renderTabs.bind(this);
    }

    getSearchEntity() {
        return this.props.match.params.entity;
    }
    getSearchHash() {
        return this.props.match.params.hash;
    }

    renderTabs(props) {
        const { idHashKeyRequest, idHashKeyRequestFormResponse } = this.props;

        return (
            <TabContent
                {...props}
                match={this.props.match}
                location={this.props.location}
                idHashKeyRequest={idHashKeyRequest}
                idHashKeyRequestFormResponse={idHashKeyRequestFormResponse}
            />
        );
    }

    render() {
        const { match, location, query, idHashKeyRequest, searchId } = this.props;
        const containerClassName = cx(styles.container, {});

        const entity = this.getSearchEntity();
        const hash = this.getSearchHash();

        return (
            <div className={cx(styles.search, "ordering-component-ui-core-wrapper")}>
                <div className={containerClassName}>
                    <InputBlock query={query} id={match.params.hash} key={searchId} />
                    <div className={styles.searchResult}>
                        <RouteWithTabs
                            path="/search/:entity/:hash"
                            render={this.renderTabs}
                            tabs={GRID_TABS}
                            tabPath="entity"
                            match={match}
                            location={location}
                        />
                    </div>
                </div>
                <AttributesFiltersForm
                    storeKey={`search-${entity}`}
                    extraFormKey={hash}
                    attributesRequestKey={"attributes"}
                    attributesRequestParams={{ idHashKeyRequest, code: Codes[entity] }}
                    filtersCode={Codes[entity]}
                    attributesValuesRequestKey={"info_filter"}
                    attributesValuesRequestParams={{ code: Codes[entity] }}
                    isKeepOnUnmount
                    withoutSave
                    withLocalFiltersList
                    key={`${entity}-${hash}`}
                />
            </div>
        );
    }
}

SearchPage.propTypes = {
    searchResults: PropTypes.object,
    openedSearch: PropTypes.bool,
    query: PropTypes.string,
    initialQuery: PropTypes.string,
    dataFilterResult: PropTypes.object,
};

export const Codes = {
    resource: "SPEC_RESOURCE",
    spec: "SPEC_INSTANCE",
    task: "ORDER_TASK",
    customer: "CUSTOMER",
    contact_person: "CONTACT_PERSON",
    appeal: "INTERACTION_REQUEST",
    callhistory: "TASK",
    clevent: "FTOP_SEARCH_CLEVENT",
    file: "SERVICE",
};

export default SearchPage;
